// extracted by mini-css-extract-plugin
export default {"container":"FileGeneratorModuleSetting_container__qFpjc"};